import { render, staticRenderFns } from "./solicitudPspAprob3.vue?vue&type=template&id=58441d7a&scoped=true"
import script from "./solicitudPspAprob3.vue?vue&type=script&lang=js"
export * from "./solicitudPspAprob3.vue?vue&type=script&lang=js"
import style0 from "./solicitudPspAprob3.vue?vue&type=style&index=0&id=58441d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58441d7a",
  null
  
)

export default component.exports